import type {
  OperationsNode,
  OperationsScheduleNode,
  OperationsTeamNode,
} from '../types/operations.types'

export const isTeamNode = (node: OperationsNode): node is OperationsTeamNode =>
  node.type === 'team'

export const isScheduleNode = (
  node: OperationsNode
): node is OperationsScheduleNode => node.type !== 'team'

/**
 * The API returns `type` as a display string ("Season", "Division",
 * "Conference"). Anything unrecognized is treated as a division, which is the
 * only child type the tab can meaningfully act on.
 */
export const toNodeType = (
  apiType: unknown
): OperationsScheduleNode['type'] => {
  const value = String(apiType ?? '').toLowerCase()
  if (value === 'season') return 'season'
  if (value === 'conference') return 'conference'
  return 'division'
}
